/* global HTMLElement */

function addMobileTableData () {
  const tables = document.querySelectorAll('table')
  if (tables.length <= 0) return

  const cellsToModify = []

  tables.forEach(t => generateHeaderDataFromTable(t, cellsToModify))

  cellsToModify.forEach(td => td.headers === null
    ? td.element !== null && td.element.classList.add('hide-for-xsmall')
    : td.element.setAttribute('data-mobile', td.headers))
}

function generateHeaderDataFromTable (table, cellsToModify) {
  const rows = [...table.querySelectorAll('tr')]
  const tableWidth = foldColSpan([...rows[0].children])
  const colHeaders = getColumnHeaders(rows, tableWidth)
  const rowHeaders = getRowHeaders(rows)
  const irregularHeaders = getIrregularHeaders(rows)
  const cells = [...table.querySelectorAll('td')]

  cells.forEach(c => cellsToModify.push(
    addHeaderDataToCell(c, tableWidth, irregularHeaders, colHeaders, rowHeaders))
  )
}

function addHeaderDataToCell (cell, tableWidth, irregularHeaders, columnHeaders, rowHeaders) {
  if (cell.innerText.trim() === '') return { element: cell, headers: null }

  const relatedIdHeaders = getRelatedIdHeaders(cell, irregularHeaders)
  const relatedColHeaders = relatedIdHeaders.length > 0 ? [] : getRelatedColumnHeaders(cell, columnHeaders, tableWidth)
  const relatedRowHeaders = relatedIdHeaders.length > 0 ? [] : getRelatedRowHeaders(cell, rowHeaders)
  const relatedHeaders = relatedIdHeaders.concat(relatedColHeaders).concat(relatedRowHeaders)

  if (relatedHeaders.length > 0) {
    const flatenedHeaders = (relatedHeaders.map(h => h.innerText)).join(' ')
    if (flatenedHeaders.length > 0) return { element: cell, headers: flatenedHeaders }
  }

  return { element: null, headers: null }
}

function getColumnHeaders (rows, tableWidth) {
  const columnHeaders = rows.filter(r => {
    const siblings = [...r.children]
    const siblingsWithoutFirst = siblings.slice(1, siblings.length)

    return foldColSpan(siblings) === tableWidth &&
      siblingsWithoutFirst.every(x => x.tagName === 'TH')
  })

  return columnHeaders <= 0
    ? []
    : columnHeaders.flatMap(r => [...r.children].filter(h =>
      h.getAttribute('scope') !== 'colgroup' &&
      h.innerText.replace('&nbsp;', '').trim() !== ''))
}

function getRelatedColumnHeaders (cell, columnHeaders, tableWidth) {
  const cellColIndex = cell.colIndex(tableWidth)
  return columnHeaders.filter(h => {
    const headerColIndex = h.colIndex(tableWidth)
    return headerColIndex === cellColIndex ||
      headerColIndex + parseInt(h.getAttribute('colspan')) - 1 === cellColIndex
  })
}

function getRowHeaders (rows) {
  return [...rows.filter(r =>
    r.firstElementChild.tagName === 'TH' &&
    r.children.length > 1 &&
    r.querySelectorAll('th').length === 1)]
    .flatMap(rh => rh.querySelector('th'))
}

function getRelatedRowHeaders (cell, rowHeaders) {
  return rowHeaders.filter(h =>
    h.parentElement === cell.parentElement ||
    (cell.parentElement.querySelector('th') === null && findPreviousMergedRowElement(cell) === h))
}

function getIrregularHeaders (rows) {
  return rows.flatMap(r => [...r.querySelectorAll('th[id]')]).filter(h => h !== null)
}

function getRelatedIdHeaders (cell, headers) {
  const cellHeaders = cell.getAttribute('headers') !== null &&
    cell.getAttribute('headers').split(' ')
  return headers
    .filter(h => cellHeaders && cellHeaders.includes(h.id))
    .sort((a, b) => cellHeaders.indexOf(a.id) > cellHeaders.indexOf(b.id) ? 1 : -1)
}

function foldColSpan (arr) {
  return arr.reduce((acc, n) => n.getAttribute('colspan') === null
    ? acc + 1
    : acc + parseInt(n.getAttribute('colspan')), 0)
}

function foldRowSpan (arr) {
  return arr.reduce((acc, n) => n.getAttribute('rowspan') === null
    ? acc + 1
    : acc + parseInt(n.getAttribute('rowspan')), 0)
}

function findPreviousMergedRowElement (cell) {
  const mergedRow = cell.parentElement.previousSiblings().find(e => e.querySelector('[rowspan]'))
  return mergedRow && mergedRow.querySelector('[rowspan]')
}

HTMLElement.prototype.getRowOffset = function () {
  const mergedCell = findPreviousMergedRowElement(this)
  return mergedCell !== null
    ? parseInt(mergedCell.getAttribute('rowspan'))
    : 0
}

HTMLElement.prototype.getColOffset = function () {
  const previousParentSiblings = this.parentElement.previousSiblings()
  return previousParentSiblings.reduce((acc, e) => e.querySelector('[rowspan]') !== null ? acc + 1 : acc, 0)
}

HTMLElement.prototype.rowIndex = function () {
  return foldRowSpan(this.parentElement.previousSiblings()) + 1
}

HTMLElement.prototype.colIndex = function (tableWidth = 0) {
  const offset = foldColSpan([...this.parentElement.children]) < tableWidth
    ? this.getColOffset()
    : 0

  return foldColSpan(this.previousSiblings()) + offset + 1
}

HTMLElement.prototype.previousSiblings = function () {
  const siblings = [...this.parentElement.children]
  const elementIndex = siblings.indexOf(this)
  return siblings.slice(0, elementIndex)
}

addMobileTableData()
// debug.getExecTime(addMobileTableData)
